export const DEFAULT_START_DATE_MINUTES = 120;
export const DEFAULT_END_DATE = Date.now() - 120000;
export const DEFAULT_START_DATE = DEFAULT_END_DATE - DEFAULT_START_DATE_MINUTES * 60 * 1000;

export const GROUPED_BY_MINUTE = 'minute';
export const GROUPED_BY_HOUR = 'hour';
export const GROUPED_BY_DAY = 'day';
export const GROUPED_BY_MONTH = 'month';
